import {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";

const SingleBlogView = (props) => {

    const[deleteClickCounter, setDeleteClickCounter] = useState(0);
    const[hasBeenSelected, setHasBeenSelected] = useState(false);
    const[propsData, setPropsData] = useState('');
    const[id, setID] = useState('');
    const[lang, setLang] = useState('en');
    
    const navigate = useNavigate();


    useEffect(() => {
        setPropsData(props.fieldData);
        setID(props.id);
        setLang(props.lang);

    }, [props]);


    console.log("Props => ", props);

    const handleClickCounter = () => {
        console.log('Handle Click Counter!');
        setHasBeenSelected(true);
        setDeleteClickCounter(counter => counter + 1);

        setTimeout(() => {
            setDeleteClickCounter(0);
            setHasBeenSelected(false);
        }, 3000);

        if(deleteClickCounter + 1  === 2){
            props.handleDelete(props.id);
        }
    } 
    
    const handleBlogDuplicate = () => {
        console.log('Handle blog duplicate!');
        navigate(`/blog-form/${props.id}/${lang}/duplicate?=true`);
        //Take the ID, open a new Blog form and then remove the id from the params
    }

    const buttonClassName = `delete-button px-3 py-1 border-2 rounded-lg transition-colors duration-300 ${
        hasBeenSelected ? 'bg-red-600 text-white' : 'bg-red-100 text-red-600 hover:bg-red-600 hover:text-white'
    }`;

    const editButtonClassName = `edit-button px-3 py-1 border-2 rounded-lg transition-colors duration-300
      bg-green-100 text-white-600 hover:bg-green-600 hover:text-white`;

    return (
        <div id={props.id} className="max-w-xs overflow-hidden bg-white rounded-lg border shadow-sm hover:shadow-md transition-shadow duration-300">
            <h2 className="px-4 pt-4 font-semibold text-gray-800">{propsData.name}</h2>
            <img src={propsData.titleimage?.url} alt={propsData.name} className="w-full h-32 object-cover object-center" />
            <div className="flex justify-between items-center p-4">
                <Link to={`/blog-form/${props.id}/${lang}`}
                      className="edit-button px-3 py-1 border rounded-lg text-indigo-600 border-indigo-600 hover:bg-indigo-600 hover:text-white transition-colors duration-300">
                    Edit
                </Link>
                <button onClick={handleClickCounter} className={buttonClassName}>
                    Delete
                </button>
                <button onClick={handleBlogDuplicate} className={editButtonClassName}>
                    Duplicate
                </button>
            </div>
        </div>
    );
}
export default SingleBlogView;